module.exports = __webpack_public_path__ + "img/m2.15e4d133.jpg";